import React from 'react';
import { CSSTransitionGroup } from 'react-transition-group';
import LazyLoad from 'lib/components/lazyload';
import { Gallery } from 'lib/components/Gallery';
import { Attachment } from 'lib/components/Attachment';
import { VideoPlayer } from 'lib/components/VideoPlayer';
import MathJaxNode from 'lib/editor/DraftEditor/plugins/formulaPlugin/components/MathJaxNode';
import { MetaInfo } from '../../components/MetaInfo';

export function SmartImage({ url, lazy, findScrollParent, onThumbnail, onClick }) {
	const img = <img src={onThumbnail(url)} style={{ cursor: onClick ? 'zoom-in' : null }} onClick={onClick} />;
	if (lazy) {
		return (
			<LazyLoad
				scroll
				resize
				findScrollParent={findScrollParent}
				placeholder={
					<span className="lazy-image-holder" dataurl={url}></span>
				}>
				<CSSTransitionGroup
					transitionName="fade"
					transitionAppear
					transitionAppearTimeout={500}
					transitionEnter={false}
					transitionLeave={false}>
					{img}
				</CSSTransitionGroup>
			</LazyLoad>
		);
	}
	return img;
}

export const createEntityRenderers = ({ onImageClick, enableImageLazyLoad, handleImageThumbnail, findScrollParent }) => ({
	'IMAGE': (children, data, { key }) => (
		<div key={key} className="image-block">
			<SmartImage
				url={data.imageUrl}
				lazy={enableImageLazyLoad}
				overflow={!!findScrollParent}
				findScrollParent={findScrollParent}
				onThumbnail={handleImageThumbnail}
				onClick={onImageClick ? (evt => onImageClick(evt, data.imageUrl)) : null}
			/>
			{data.imageUrl && data.name && <figcaption>{data.name}</figcaption> }
		</div>
	),
	'VIDEO': (children, data, { key }) => [
			<VideoPlayer key={key} {...data} />
		,
		data.name && <figcaption key={key + 'caption'}>{data.name}</figcaption>
	],
	'GALLERY': (children, data, { key }) => [
		<Gallery key={key} {...data} />,
		data.name && <figcaption key={key + 'caption'}>{data.name}</figcaption>
	],
	'ATTACHMENT': (children, data, { key }) => <Attachment key={key} {...data} />,
	'LINK': (children, data, { key }) => {
		return <a key={key} href={data.url} target="_blank">{children}</a>
	},
	'PLACEHOLDER': () => null,
	'INLINETEX': (children, data, { key }) => <MathJaxNode key={key} inline children={data.teX} />,
	'HR': (children, data, { key }) => <hr key={key} />,
	'META': (children, data, { key }) => <MetaInfo key={key} {...data} defaultCollapsed />
});



// WEBPACK FOOTER //
// ./lib/viewer/renderers/createEntityRenderers.js